import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, NO_ACCESS_MESSAGE, hasAnyRequiredActionsInAnySpace } from "utils/access";
import { Action } from "types/generated";

export const WORKER_POOL_CREATE_ACCESS_TYPES = [Action.SpaceAdmin, Action.WorkerPoolCreate];

/**
 * Hook that returns whether current user can create worker pools
 * User needs to have SpaceAdmin or WorkerPoolCreate actions in at least one space
 * @returns {AccessResult} Object indicating if user can create worker pools and a message if not
 */
const useCanCreateWorkerPool = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = hasAnyRequiredActionsInAnySpace(WORKER_POOL_CREATE_ACCESS_TYPES, viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateWorkerPool;
